import React, { useEffect, useRef } from 'react';
import styles from './AdSense.module.css';

const AD_CLIENT = import.meta.env.VITE_ADSENSE_CLIENT_ID;
const AD_SLOT_BANNER = import.meta.env.VITE_ADSENSE_SLOT_BANNER;

/**
 * AdSense script'ini head'e ekler (bir kez).
 * VITE_ADSENSE_CLIENT_ID tanımlıysa çalışır.
 */
export function useAdSenseScript() {
  const injected = useRef(false);

  useEffect(() => {
    if (!AD_CLIENT || injected.current) return;
    if (document.querySelector('script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]')) {
      injected.current = true;
      return;
    }

    const script = document.createElement('script');
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT}`;
    script.async = true;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
    injected.current = true;
  }, []);
}

/**
 * Tek bir reklam alanı (banner, rectangle vb.).
 * @param {string} slot - data-ad-slot (örn. "1234567890")
 * @param {string} format - "auto" | "rectangle" | "horizontal" | "vertical"
 * @param {string} layout - "in-article" vb. (isteğe bağlı)
 * @param {string} className - ek CSS sınıfı
 */
export function AdUnit({ slot, format = 'auto', layout, className = '', style = {} }) {
  const elRef = useRef(null);
  useAdSenseScript();

  useEffect(() => {
    if (!AD_CLIENT || !slot || !elRef.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.warn('AdSense push error:', e);
    }
  }, [slot]);

  if (!AD_CLIENT || !slot) return null;

  return (
    <div className={`${styles.wrapper} ${className}`} style={style}>
      <ins
        ref={elRef}
        className="adsbygoogle"
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={format === 'auto' ? 'true' : undefined}
        {...(layout ? { 'data-ad-layout': layout } : {})}
      />
    </div>
  );
}

/**
 * Varsayılan banner reklamı (env'deki VITE_ADSENSE_SLOT_BANNER kullanır).
 * Layout'ta tek satır kullanım için.
 */
export function AdSenseBanner() {
  if (!AD_CLIENT || !AD_SLOT_BANNER) return null;
  return (
    <AdUnit
      slot={AD_SLOT_BANNER}
      format="horizontal"
      className={styles.banner}
    />
  );
}

export default AdSenseBanner;
